module.exports = __webpack_public_path__ + "img/M651.76aafe6f.jpg";